/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Account Manager API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
/**
 *
 * @export
 * @interface AuthResponseDto
 */
export interface AuthResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof AuthResponseDto
     */
    isAuthenticated?: boolean;
    /**
     *
     * @type {string}
     * @memberof AuthResponseDto
     */
    message?: string | null;
}

/**
 * Check if a given object implements the AuthResponseDto interface.
 */
export function instanceOfAuthResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthResponseDtoFromJSON(json: any): AuthResponseDto {
    return AuthResponseDtoFromJSONTyped(json, false);
}

export function AuthResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AuthResponseDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        isAuthenticated: !exists(json, 'is_authenticated') ? undefined : json['is_authenticated'],
        message: !exists(json, 'message') ? undefined : json['message'],
    };
}

export function AuthResponseDtoToJSON(value?: AuthResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        is_authenticated: value.isAuthenticated,
        message: value.message,
    };
}
